import { createBrowserRouter } from 'react-router-dom';

import { routes } from '@/pages/_routes';

export const router = createBrowserRouter(routes);
